import { definePath } from '../../router/definePath';

export const ParentalControlsPaths = {
  overview: definePath('authenticated', { de: '/konto/jugendschutz', en: '/account/parental-controls' }),
} as const;
